import { isEqual } from './isEqual.js';
import { CalibrationTypes } from '../enums/index.js';
import { logging as cornerstoneLogging } from '@cornerstonejs/utils';
const cs3dLogger = cornerstoneLogging.metadataLog.getLogger('utilities.getPixelSpacingInformation');
const projectionRadiographSOPClassUIDs = new Set([
    '1.2.840.10008.5.1.4.1.1.1',
    '1.2.840.10008.5.1.4.1.1.1.1',
    '1.2.840.10008.5.1.4.1.1.1.1.1',
    '1.2.840.10008.5.1.4.1.1.1.2',
    '1.2.840.10008.5.1.4.1.1.1.2.1',
    '1.2.840.10008.5.1.4.1.1.1.3',
    '1.2.840.10008.5.1.4.1.1.1.3.1',
    '1.2.840.10008.5.1.4.1.1.12.1',
    '1.2.840.10008.5.1.4.1.1.12.1.1',
    '1.2.840.10008.5.1.4.1.1.12.2',
    '1.2.840.10008.5.1.4.1.1.12.2.1',
    '1.2.840.10008.5.1.4.1.1.12.3',
]);
export function getERMF(instance) {
    const { PixelSpacing, ImagerPixelSpacing, EstimatedRadiographicMagnificationFactor: ermf, DistanceSourceToDetector: sid, DistanceSourceToEntrance: soe, DistanceSourceToPatient: sod = soe, } = instance;
    if (ermf > 1) {
        return ermf;
    }
    if (sod < sid) {
        return sid / sod;
    }
    if (ImagerPixelSpacing?.[0] > PixelSpacing?.[0]) {
        return true;
    }
}
export function calculateRadiographicPixelSpacing(instance) {
    const { PixelSpacing, ImagerPixelSpacing, PixelSpacingCalibrationType } = instance;
    const isProjection = true;
    if (PixelSpacing && PixelSpacingCalibrationType === 'GEOMETRY') {
        if (isEqual(PixelSpacing, ImagerPixelSpacing)) {
            cs3dLogger.warn('Calibration type is geometry, but pixel spacing and imager pixel spacing identical', PixelSpacing, ImagerPixelSpacing);
        }
        return {
            PixelSpacing,
            type: CalibrationTypes.ERMF,
            isProjection,
        };
    }
    if (PixelSpacing && PixelSpacingCalibrationType === 'FIDUCIAL') {
        return {
            PixelSpacing,
            type: CalibrationTypes.CALIBRATED,
            isProjection,
        };
    }
    if (ImagerPixelSpacing) {
        const ermf = getERMF(instance);
        if (ermf > 1) {
            const correctedPixelSpacing = ImagerPixelSpacing.map((pixelSpacing) => pixelSpacing / ermf);
            return {
                PixelSpacing: correctedPixelSpacing,
                type: CalibrationTypes.ERMF,
                isProjection,
            };
        }
        if (ermf === true) {
            return {
                PixelSpacing,
                type: CalibrationTypes.ERMF,
                isProjection,
            };
        }
        if (ermf) {
            cs3dLogger.error('Illegal ERMF value:', ermf);
        }
        return {
            PixelSpacing: PixelSpacing || ImagerPixelSpacing,
            type: CalibrationTypes.PROJECTION,
            isProjection,
        };
    }
    return {
        PixelSpacing,
        type: CalibrationTypes.UNKNOWN,
        isProjection,
    };
}
export function getPixelSpacingInformation(instance) {
    const { PixelSpacing, SOPClassUID } = instance;
    const isProjection = projectionRadiographSOPClassUIDs.has(SOPClassUID);
    if (isProjection) {
        return calculateRadiographicPixelSpacing(instance);
    }
    return {
        PixelSpacing,
        type: CalibrationTypes.NOT_APPLICABLE,
        isProjection: false,
    };
}
export default getPixelSpacingInformation;
